<template>
	<base-modal :show="!!error" title="An error occurred" @close="handleError">
		<p>{{ error }}</p>
	</base-modal>
	<div class="card mt-5 text-info" style="background-color: #263238">
		<div class="card-body">
			<h1 class="card-title border-bottom">Team Info</h1>
			<div v-if="userData3.league">
				<b>Your League:</b>
				{{ userData3.league }}
			</div>
			<div
				v-if="
					(userData3.userType === 'Player' ||
						userData3.userType === 'Family Member') &&
					getTeams.length > 0
				"
			>
				<p>
					Don't see your team? Skip for now and contact your league manager to
					have it added!
				</p>
			</div>
			<form @submit.prevent="submitTeamForm">
				<div class="row g-2">
					<div
						v-if="getTeams.length > 0 && userData3.userType !== 'League Manager'"
						v-show="!addTeam"
						class="form-floating"
					>
						<select
							class="form-select"
							v-model.trim="userTeam"
							id="floatingSelectGridT"
						>
							<option v-for="team in getTeams" :key="team" :value="{team: team.team, id: team.id}">
								{{ team.team }}
							</option>
						</select>
						<label for="floatingSelectGridL">Teams</label>
					</div>
					<div v-else-if="userData3.userType !== 'League Manager' && userData3.userType !== 'Coach'">
						<p>
							No teams in your league! Contact your league manager to have your
							team added!
						</p>
					</div>
					<div v-else-if="userData3.userType !== 'Coach'">
						You can add teams to your league after completing the sign up and
						navigating to the Manage League page under the <i>League Tab</i>
					</div>
					<div v-if="userData3.userType === 'Coach'" class="mt-4">
						<button
							v-show="showAddTeamBtn"
							type="button"
							class="btn btn-outline-light btn-lg"
							@click="hideAddBtn"
						>
							Don't see your team coach? Add it!
						</button>
					</div>
					<div v-show="addTeam" class="row g-2">
						<h4 class="mt-3">Add your team!</h4>
						<div class="form-floating">
							<input
								type="text"
								class="form-control"
								id="floatingNewTeam"
								v-model.trim="addNewTeam"
							/>
							<label for="floatingNewTeam">Your Team Name</label>
						</div>
					</div>
					<div v-if="getTeams.length > 0" class="mt-3 mb-3">
						<button
							v-if="showSelectATeamBtn"
							type="button"
							class="btn btn-dark btn-lg"
							@click="hideSelectBtn"
						>
							Find your team!
						</button>
					</div>
					<div class="row">
						<div class="col-4 me-1"></div>
						<div
							v-if="userTeam.length > 1 || userData3.userType !== 'League Manager'"
							class="col-4 mt-2"
						>
							<button :disabled="isLoading" class="btn btn-outline-info btn-lg">
								<div v-show="isLoading">
									<i class="fa-solid fa-baseball fa-spin"></i>
									Loading...
								</div>
								<div v-show="!isLoading">Next</div>
							</button>
						</div>
						<div
							class="col-3 mt-2 text-end"
							v-if="
								userTeam.length < 1 || userData3.userType === 'League Manager'
							"
						>
							<button
								:disabled="isLoading"
								class="btn btn-dark btn-lg"
								type="button"
								@click="skipStep"
							>
								<span v-if="userData3.userType === 'League Manager'">
									Finish</span
								>
								<span v-else>Skip</span>
							</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	emits: ['team-step-complete', 'skip-step', 'user-team'],
	props: ['userData3', 'stepComplete'],
	data() {
		return {
			isLoading: false,
			userTeam: {
				team: '',
				id: ''
			},
			addNewTeam: '',
			error: null,
			addTeam: false,
			showAddTeamBtn: true,
			showSelectATeamBtn: false,
			completed: false,
		};
	},
	created() {
		this.fetchTeams();
	},
	computed: {
		getTeams() {
			return this.$store.getters['teams/allTeams'];
		},
		getUserType() {
			return this.$store.getters.userType;
		},
	},
	methods: {
		addATeam() {
			this.userTeam = '';
			this.addTeam = true;
		},
		hideAddBtn() {
			this.showAddTeamBtn = false;
			this.showSelectATeamBtn = true;
			this.addTeam = true;
			this.userTeam = '';
		},
		hideSelectBtn() {
			this.showAddTeamBtn = true;
			this.showSelectATeamBtn = false;
			this.addTeam = false;
			this.addNewTeam = '';
		},
		skipStep() {
			const payloadExistingTeam = {
				team: this.userTeam.team,
				teamId: this.userTeam.id
			};
			this.$emit('user-team', payloadExistingTeam);
			this.$emit('team-step-complete');
			this.$store.dispatch('setComponentKey')

		},
		async submitTeamForm() {
			this.isLoading = true;
			// this.validateForm();
			// if (!this.formIsValid) {
			// 	return;
			// }
			if (this.userTeam === '' && this.addNewTeam !== '') {
				const payloadNewTeam = {
					team: this.addNewTeam,
				};
				try {
					await this.$store.dispatch('teams/addNewTeam', payloadNewTeam);
					this.$emit('team-step-complete');

				} catch (err) {
					this.error = err.message || 'Set user info failed... Try again.';
				}
				this.$store.dispatch('setComponentKey')
				this.isLoading = false;
			} else {
				const payloadExistingTeam = {
					team: this.userTeam.team,
					teamId: this.userTeam.id
				};
				try {
					this.$emit('user-team', payloadExistingTeam);
					this.$emit('team-step-complete');
				} catch (err) {
					this.error = err.message || 'Set user info failed... Try again.';
				}
				this.$store.dispatch('setComponentKey')
				this.completed = true;
				this.isLoading = false;
			}
		},
		signUpComplete() {
			setTimeout(() => {
				const redirectUrl = '/profile';
				this.$router.replace(redirectUrl);
			}, 1000);
		},
		handleError() {
			this.error = null;
		},
		async fetchTeams() {
			
			try {
				this.isLoading = true;
				await this.$store.dispatch('teams/fetchTeams');
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			this.isLoading = false;
		},
	},
};
</script>
